import React, { useMemo, Fragment, useState, useEffect, useContext } from 'react';
import { MaterialReactTable } from 'material-react-table';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { useOutletContext } from 'react-router-dom';

const AccountTeamTable = ({ tableData, setTableData }) => {

    /**
     * /////from dialog/////
     * const memberData = {
            teamMemberId: data.name.id,
            name: `${memberDetails.FirstName} ${memberDetails.LastName}`,
            email: memberDetails.EmailAddress,
            contact: memberDetails.ContactNo,
            jobPosition: data.job_position,
            bioId: data.bio.id,
            bioTitle: data.bio.selectOptionLabel,
        }
     */
        const {refClientAccountCmsData}=useOutletContext();
      
    const fetchAccountTeamMemberCmsData = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["ClientAccounts.AccountTeamMembers"]) {
            const adminClientSubAccountCmsDataLabel = refClientAccountCmsData?.Components["ClientAccounts.AccountTeamMembers"];
            return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key)
        }
        return '';

    }
        const fetchCommonComponentCMSLabel = (key) => {
            if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["CommonComponent"]) {
                const commonComponentLabel = refClientAccountCmsData?.Components["CommonComponent"];
                return returnLabel(commonComponentLabel?.Labels, key)
            }
            return '';
        }
    
        const returnLabel = (labelArray = [], key) => {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
        }

    const columns = useMemo(
        () => [
            {
                accessorKey: 'name',
                header: fetchAccountTeamMemberCmsData('AccountTeamMembers.Name'),
                filterFn: 'contains'
            },
            {
                accessorKey: 'email',
                header: fetchAccountTeamMemberCmsData('AccountTeamMembers.Email'),
                filterFn: 'contains'
            },
            {
                accessorKey: 'jobPosition',
                header: fetchAccountTeamMemberCmsData('AccountTeamMembers.JobTitle'),
                filterFn: 'contains'
            },
            {
                accessorKey: 'contact',
                header: fetchAccountTeamMemberCmsData('AccountTeamMembers.Phone'),
                filterFn: 'contains'
            },
            {
                accessorKey: 'bioTitle',
                header: fetchAccountTeamMemberCmsData('AccountTeamMembers.Bio'),
                filterFn: 'contains'
            }
        ],
        [],
    );

    const removeAccountTeamMemberTableEntry = ({ idToBeRemoved }) => {
        const newList = !!tableData && tableData.filter((item) => {
            if (item.teamMemberId !== idToBeRemoved) {
                return item
            }
        })
        setTableData(newList)
    }

    return (
        <MaterialReactTable
            columns={columns}
            data={tableData}
            layoutMode="grid"
            enableGlobalFilter={false}
            enableDensityToggle={false}
            muiTablePaginationProps={{
                labelRowsPerPage: fetchCommonComponentCMSLabel('Common.Rowsperpage')
            }}
            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: fetchAccountTeamMemberCmsData('AccountTeamMembers.Actions'),
                },
                'mrt-row-drag': {
                    header: fetchAccountTeamMemberCmsData('AccountTeamMembers.Move'),
                },
            }}
            enableTopToolbar={!!tableData && tableData.length ? true : false}
            enableBottomToolbar={!!tableData && tableData.length ? true : false}
            initialState={{
                density: 'compact'
            }}

            /** !!!!!!!!!! for drag and drop !!!!!!!!!! */
            /**for drag and drop */
            enableRowOrdering
            /**sorting is disabled infavour of drag and drop */
            enableSorting={false}
            muiTableBodyRowDragHandleProps={({ table }) => ({
                onDragEnd: () => {
                    const { draggingRow, hoveredRow } = table.getState();
                    if (hoveredRow && draggingRow) {
                        tableData.splice(
                            hoveredRow.index,
                            0,
                            tableData.splice(draggingRow.index, 1)[0],
                        );
                        setTableData([...tableData]);
                    }
                },
            })}

            /** !!!!!!!!!! row actions !!!!!!!!!! */
            enableRowActions
            renderRowActions={({ row, table }) => {
                const Id = row.original.Id;
                const Status = row?.original.Status;
                return (
                    <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                        <IconButton
                            onClick={() => {
                                const id = row.original.teamMemberId

                                removeAccountTeamMemberTableEntry({ idToBeRemoved: id })
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                )
            }}
        />
    )
}
export default AccountTeamTable